/* 온제나 블로그 홈 — 묶음의 SHOW MORE
   워드프레스는 카드 8장을 다 그려 두고 앞 4장만 보인 뒤 버튼으로 나머지를 편다.
   여기서도 같은 방식이다 — 서버가 8장을 보내고 화면에서만 접는다. */
(function(){
  document.addEventListener("DOMContentLoaded", function(){
    document.querySelectorAll(".onz-cluster").forEach(function(cluster){
      var grid = cluster.querySelector(".onz-quad-grid");
      var btn  = cluster.querySelector(".onz-load-more");
      if (!grid || !btn) return;
      var cards = Array.from(grid.children);
      var firstN = parseInt(btn.getAttribute("data-first") || "4", 10);
      if (cards.length <= firstN) { btn.remove(); return; }

      var hidden = cards.slice(firstN);
      hidden.forEach(function(c){ c.hidden = true; });
      var openLabel  = btn.getAttribute("data-more") || btn.textContent.trim() || "SHOW MORE";
      var closeLabel = btn.getAttribute("data-less") || "SHOW LESS";
      btn.textContent = openLabel;
      btn.setAttribute("aria-expanded", "false");

      btn.addEventListener("click", function(){
        var open = btn.getAttribute("aria-expanded") === "true";
        hidden.forEach(function(c){ c.hidden = open; });
        btn.setAttribute("aria-expanded", open ? "false" : "true");
        btn.textContent = open ? openLabel : closeLabel;
        if (open) cluster.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  });
})();
